import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { UploadRv } from "../../model/domain/UploadRv";
import { UploadTicket } from "../../model/domain/UploadTicket";
import { UploadCarga } from "../../model/domain/UploadCarga";

@Injectable({
  providedIn: "root",
})
export class UploadService {
  private readonly name = "load";

  constructor(private http: HttpClient) {}

  uploadTicket(ticketsFile: UploadTicket) {
    var formData = new FormData();
    formData.append("file", ticketsFile.fileBase64);
    formData.append("ticketTypes", ticketsFile.ticketTypesId);

    return this.http.post(
      `${environment.apiUrls.tickets}/ticket-upload`,
      formData
    );
  }

  ticketTemplate(ticketTypesId: number) {
    return this.http.get(
      `${environment.apiUrls.tickets}/ticket-upload/download-ticket-template/${ticketTypesId}`,
      {
        responseType: "blob",
      }
    );
  }

  uploadCarga(ticketsFile: UploadCarga) {
    var formData = new FormData();
    formData.append("file", ticketsFile.fileBase64);
    formData.append("loadType", ticketsFile.loadTypesId);

    return this.http.post(`${environment.apiUrls.loads}/load-data`, formData);
  }

  downloadTemplate(ticketTypesId: number) {
    return this.http.get(
      `${environment.apiUrls.loads}/download-load-template/${ticketTypesId}`,
      {
        responseType: "blob",
      }
    );
  }
}
